export default {
  background_image: 'Imagen de fondo',
  file_too_large: 'El archivo es demasiado grande. El tamaño máximo es {{max}} MB.',
  upload_failed: 'Error al subir el archivo. Inténtalo de nuevo.',
};
